export default {
  youth: {
    baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/youth/",
    videoUrl:
      "https://eaydu-video.oss-cn-beijing.aliyuncs.com/youth/01.mp4",
    title: "少年张謇",
    setNum: 26,
    videoFormat: "mp4",
    num: "01",
    license: "（苏）动审字[2017]第017号"
  }, drum: {
    baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/drum/",
    videoUrl:
      "https://eaydu-video.oss-cn-beijing.aliyuncs.com/drum/01.mp4",
    title: "铜鼓奇缘",
    setNum: 14,
    videoFormat: "mp4",
    num: "01",
    license: "（桂）动审字[2019]第001号"
  }, star: {
    baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/star/",
    videoUrl:
      "https://eaydu-video.oss-cn-beijing.aliyuncs.com/star/01.mp4",
    title: "哈喽！葡星人",
    setNum: 26,
    videoFormat: "mp4",
    num: "01",
    license: "（沪）动审字[2016]第013号"
  }, star2: {
    baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/star2/",
    videoUrl:
      "https://eaydu-video.oss-cn-beijing.aliyuncs.com/star2/01.mp4",
    title: "哈喽！葡星人之极训特工",
    setNum: 26,
    videoFormat: "mp4",
    num: "01",
    license: "（沪）动审字[2018]第001号"
  }, protected: {
    baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/protected/",
    videoUrl:
      "https://eaydu-video.oss-cn-beijing.aliyuncs.com/protected/01.mp4",
    title: "魔能圣甲：守护者",
    setNum: 26,
    videoFormat: "mp4",
    num: "01",
    license: "（粤）动审字【2019】第014号"
  }, hero: {
    baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/hero/",
    videoUrl:
      "https://eaydu-video.oss-cn-beijing.aliyuncs.com/hero/01.mp4",
    title: "么么侠 第一季",
    setNum: 6,
    videoFormat: "mp4",
    num: "01",
    license: "（苏）动审字【2022】第005号"
  }, yunnan1: {
    baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/yunnan1/",
    videoUrl:
      "https://eaydu-video.oss-cn-beijing.aliyuncs.com/yunnan1/01.mp4",
    title: "穿越云南三千年-云小志漫游记",
    setNum: 10,
    videoFormat: "mp4",
    num: "01",
    license: "（云）动审字[2020]第002号"
  }, yunnan2: {
    baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/yunnan2/",
    videoUrl:
      "https://eaydu-video.oss-cn-beijing.aliyuncs.com/yunnan2/01.mp4",
    title: "穿越云南三千年-云小志漫游记（第二季）",
    setNum: 11,
    videoFormat: "mp4",
    num: "01",
    license: "（云）动审字[2022]第001号"
  }, 
  Onepage02: {
    baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/Onepage02/",
    videoUrl:
      "https://eaydu-video.oss-cn-beijing.aliyuncs.com/Onepage02/01.mp4",
    title: "翻开这一页第二季",
    setNum: 13,
    videoFormat: "mp4",
    num: "01",
    license: "（湘）动审字[2016]第008号"
  }, Onepage03: {
    baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/Onepage03/",
    videoUrl:
      "https://eaydu-video.oss-cn-beijing.aliyuncs.com/Onepage03/01.mp4",
    title: "翻开这一页第三季",
    setNum: 10,
    videoFormat: "mp4",
    num: "01",
    license: "（湘）动审字[2017]第004号"
  }, moral01: {
    baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/moral01/",
    videoUrl:
      "https://eaydu-video.oss-cn-beijing.aliyuncs.com/moral01/01.mp4",
    title: "老子道德三百问（第一季）",
    setNum: 50,
    videoFormat: "MP4",
    num: "01",
    license: "（冀）动审字[2014]第001号"
  }, moral02: {
    baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/moral02/",
    videoUrl:
      "https://eaydu-video.oss-cn-beijing.aliyuncs.com/moral02/01.mp4",
    title: "老子道德三百问（第二季）",
    setNum: 50,
    videoFormat: "MP4",
    num: "01",
    license: "（冀）动审字[2014]第002号"
  }, bus1: {
    baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/bus1/",
    videoUrl:
      "https://eaydu-video.oss-cn-beijing.aliyuncs.com/bus1/01.mp4",
    title: "阿古顿巴第一季",
    setNum: 26,
    videoFormat: "mp4",
    num: "01",
    license: "（藏）动审字【2017】第 01 号"
  }, bus2: {
    baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/bus2/",
    videoUrl:
      "https://eaydu-video.oss-cn-beijing.aliyuncs.com/bus2/01.mp4",
    title: "阿古顿巴第二季",
    setNum: 26,
    videoFormat: "mp4",
    num: "01",
    license: "（藏）动审字【2018】第 1 号"
  }, six: {
    baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/six/",
    videoUrl:
      "https://eaydu-video.oss-cn-beijing.aliyuncs.com/six/01.mp4",
    title: "蔡六",
    setNum: 24,
    videoFormat: "mp4",
    num: "01",
    license: "（闽）动审字[2011]第021号"
  }, legend1: {
    baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/legend1/",
    videoUrl:
      "https://eaydu-video.oss-cn-beijing.aliyuncs.com/legend1/01.mp4",
    title: "瓷都传奇之牛牛和妞妞",
    setNum: 26,
    videoFormat: "mp4",
    num: "01",
    license: "（闽）动审字[2016]第008号"
  }, 
  // cities: {
  //   baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/cities/",
  //   videoUrl:
  //     "https://eaydu-video.oss-cn-beijing.aliyuncs.com/cities/01.mp4",
  //   title: "嘟嘟镇",
  //   setNum: 52,
  //   videoFormat: "mp4",
  //   num: "01",
  //   license: "（浙）动审字【2016】035号"
  // }, 
  mouse: {
    baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/mouse/",
    videoUrl:
      "https://eaydu-video.oss-cn-beijing.aliyuncs.com/mouse/01.mp4",
    title: "功夫家族之笨笨鼠",
    setNum: 30,
    videoFormat: "mp4",
    num: "01",
    license: "（闽）动审字[2013]第050号"
  }, dragon: {
    baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/dragon/",
    videoUrl:
      "https://eaydu-video.oss-cn-beijing.aliyuncs.com/dragon/01.mp4",
    title: "卡西龙之寻龙记",
    setNum: 26,
    videoFormat: "mp4",
    num: "01",
    license: "（闽）动审字[2012]第018号"
  }, stone: {
    baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/stone/",
    videoUrl:
      "https://eaydu-video.oss-cn-beijing.aliyuncs.com/stone/01.mp4",
    title: "石头娃",
    setNum: 26,
    videoFormat: "mp4",
    num: "01",
    license: "（苏）动审字[2018]第009号"
  }, house: {
    baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/house/",
    videoUrl:
      "https://eaydu-video.oss-cn-beijing.aliyuncs.com/house/01.mp4",
    title: "土楼探险之牛牛和妞妞",
    setNum: 26,
    videoFormat: "mp4",
    num: "01",
    license: "（闽）动审字[2013]第017号"
  }, bath: {
    baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/bath/",
    videoUrl:
      "https://eaydu-video.oss-cn-beijing.aliyuncs.com/bath/01.mp4",
    title: "卫浴也疯狂",
    setNum: 30,
    videoFormat: "mp4",
    num: "01",
    license: "（苏）动审字[2015]第002号"
  }, bear: {
    baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/bear/",
    videoUrl:
      "https://eaydu-video.oss-cn-beijing.aliyuncs.com/bear/01.mp4",
    title: "小熊优恩",
    setNum: 26,
    videoFormat: "mp4",
    num: "01",
    license: "（闽）动审字[2015]第019号"
  }, earthCountry: {
    baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/earthCountry/",
    videoUrl:
      "https://eaydu-video.oss-cn-beijing.aliyuncs.com/earthCountry/01.mp4",
    title: "探索地球村",
    setNum: 20,
    videoFormat: "mp4",
    num: "01",
    license: "（黑）动审字【2007】第002号"
  }, sweet: {
    baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/sweet/",
    videoUrl:
      "https://eaydu-video.oss-cn-beijing.aliyuncs.com/sweet/01.mp4",
    title: "甜蜜日记",
    setNum: 13,
    videoFormat: "mp4",
    num: "01",
    license: "（鄂）动审字（2021）第003号"
  }, toy2: {
    baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/toy2/",
    videoUrl:
      "https://eaydu-video.oss-cn-beijing.aliyuncs.com/toy2/01.mp4",
    title: "托雷的玩具城第二部",
    setNum: 25,
    videoFormat: "mp4",
    num: "01",
    license: "（浙）动审字[2019]第036号"
  }, toy1: {
    baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/toy1/",
    videoUrl:
      "https://eaydu-video.oss-cn-beijing.aliyuncs.com/toy1/01.mp4",
    title: "托雷的玩具城第一部",
    setNum: 25,
    videoFormat: "mp4",
    num: "01",
    license: "（浙）动审字[2019]第027号"
  }, house2: {
    baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/house2/",
    videoUrl:
      "https://eaydu-video.oss-cn-beijing.aliyuncs.com/house2/01.mp4",
    title: "玩个玩具之芭比的大房子",
    setNum: 1,
    videoFormat: "mp4",
    num: "01",
    license: "重庆市网络视听节目备案号：2207184220304002"
  }, pig: {
    baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/pig/",
    videoUrl:
      "https://eaydu-video.oss-cn-beijing.aliyuncs.com/pig/01.mp4",
    title: "小泼猴与哼哼猪",
    setNum: 20,
    videoFormat: "mp4",
    num: "01",
    license: "重庆市网络视听节目备案号：2207184220504002"
  }, teeth: {
    baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/teeth/",
    videoUrl:
      "https://eaydu-video.oss-cn-beijing.aliyuncs.com/teeth/01.mp4",
    title: "牙牙精灵战队",
    setNum: 20,
    videoFormat: "mp4",
    num: "01",
    license: "（鄂）动审字[2019]第003号"
  }, workshop: {
    baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/workshop/",
    videoUrl:
      "https://eaydu-video.oss-cn-beijing.aliyuncs.com/workshop/01.mp4",
    title: "玩个玩具之彩泥霓虹工坊",
    setNum: 1,
    videoFormat: "mp4",
    num: "01",
    license: "重庆市网络视听节目备案号：2207184220304002"
  }, machine: {
    baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/machine/",
    videoUrl:
      "https://eaydu-video.oss-cn-beijing.aliyuncs.com/machine/01.mp4",
    title: "玩个玩具之迪士尼陶艺机",
    setNum: 1,
    videoFormat: "mp4",
    num: "01",
    license: "重庆市网络视听节目备案号：2207184220304002"
  }, mokey: {
    baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/mokey/",
    videoUrl:
      "https://eaydu-video.oss-cn-beijing.aliyuncs.com/mokey/01.mp4",
    title: "玩个玩具之翻斗猴子",
    setNum: 1,
    videoFormat: "mp4",
    num: "01",
    license: "重庆市网络视听节目备案号：2207184220304002"
  }, eggs: {
    baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/eggs/",
    videoUrl:
      "https://eaydu-video.oss-cn-beijing.aliyuncs.com/eggs/01.mp4",
    title: "玩个玩具之疯狂动物城奇趣蛋",
    setNum: 1,
    videoFormat: "mp4",
    num: "01",
    license: "重庆市网络视听节目备案号：2207184220304002"
  }, waterbox: {
    baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/waterbox/",
    videoUrl:
      "https://eaydu-video.oss-cn-beijing.aliyuncs.com/waterbox/01.mp4",
    title: "玩个玩具之欢乐水族箱",
    setNum: 1,
    videoFormat: "mp4",
    num: "01",
    license: "重庆市网络视听节目备案号：2207184220304002"
  }, coffee: {
    baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/coffee/",
    videoUrl:
      "https://eaydu-video.oss-cn-beijing.aliyuncs.com/coffee/01.mp4",
    title: "玩个玩具之欢迎来到兔叽咖啡厅",
    setNum: 1,
    videoFormat: "mp4",
    num: "01",
    license: "重庆市网络视听节目备案号：2207184220304002"
  }, strangeegg: {
    baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/strangeegg/",
    videoUrl:
      "https://eaydu-video.oss-cn-beijing.aliyuncs.com/strangeegg/01.mp4",
    title: "玩个玩具之佩奇的生日礼物奇趣蛋",
    setNum: 1,
    videoFormat: "mp4",
    num: "01",
    license: "重庆市网络视听节目备案号：2207184220304002"
  }, playground: {
    baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/playground/",
    videoUrl:
      "https://eaydu-video.oss-cn-beijing.aliyuncs.com/playground/01.mp4",
    title: "玩个玩具之星海湾游乐场游记",
    setNum: 1,
    videoFormat: "mp4",
    num: "01",
    license: "重庆市网络视听节目备案号：2207184220304002"
  }, rabbit: {
    baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/rabbit/",
    videoUrl:
      "https://eaydu-video.oss-cn-beijing.aliyuncs.com/rabbit/01.mp4",
    title: "玩个玩具之一只神奇的兔子",
    setNum: 1,
    videoFormat: "mp4",
    num: "01",
    license: "重庆市网络视听节目备案号：2207184220304002"
  }, penguin: {
    baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/penguin/",
    videoUrl:
      "https://eaydu-video.oss-cn-beijing.aliyuncs.com/penguin/01.mp4",
    title: "玩个玩具之拯救企鹅",
    setNum: 1,
    videoFormat: "mp4",
    num: "01",
    license: "重庆市网络视听节目备案号：2207184220304002"
  }, youngduck: {
    baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/youngduck/",
    videoUrl:
      "https://eaydu-video.oss-cn-beijing.aliyuncs.com/youngduck/01.mp4",
    title: "玩个玩具之抓住那个捣蛋鬼",
    setNum: 1,
    videoFormat: "mp4",
    num: "01",
    license: "重庆市网络视听节目备案号：2207184220304002"
  }, code: {
    baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/code/",
    videoUrl:
      "https://eaydu-video.oss-cn-beijing.aliyuncs.com/code/01.mp4",
    title: "百越历险记之壮锦密码",
    setNum: 13,
    videoFormat: "mp4",
    num: "01",
    license: "（桂）动审字[2017]第001号"
  }, Onepage04: {
    baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/Onepage04/",
    videoUrl:
      "https://eaydu-video.oss-cn-beijing.aliyuncs.com/Onepage04/01.mp4",
    title: "翻开这一页第四季",
    setNum: 10,
    videoFormat: "mp4",
    num: "01",
    license: "（湘）动审字[2021]第003号"
  }, Onepage01: {
    baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/Onepage01/",
    videoUrl:
      "https://eaydu-video.oss-cn-beijing.aliyuncs.com/Onepage01/01.mp4",
    title: "翻开这一页第一季",
    setNum: 26,
    videoFormat: "mp4",
    num: "01",
    license: "（湘）动审字[2014]第004号"
  }, growth: {
    baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/growth/",
    videoUrl:
      "https://eaydu-video.oss-cn-beijing.aliyuncs.com/growth/01.mp4",
    title: "嗨，顾得白之快乐成长",
    setNum: 80,
    videoFormat: "mp4",
    num: "01",
    license: "（浙）动审字[2019]第051号"
  }, precious: {
    baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/precious/",
    videoUrl:
      "https://eaydu-video.oss-cn-beijing.aliyuncs.com/precious/01.mp4",
    title: "嗨，顾得白之爱最珍贵",
    setNum: 80,
    videoFormat: "mp4",
    num: "01",
    license: "（浙）动审字[2019]第051号"
  }, car: {
    baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/car/",
    videoUrl:
      "https://eaydu-video.oss-cn-beijing.aliyuncs.com/car/01.mp4",
    title: "轰轰龙之超级汽车救援队",
    setNum: 20,
    videoFormat: "mp4",
    num: "01",
    license: "重庆市网络视听节目备案号：2207184220504001"
  }, wood: {
    baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/wood/",
    videoUrl:
      "https://eaydu-video.oss-cn-beijing.aliyuncs.com/wood/01.mp4",
    title: "吉木故事会",
    setNum: 26,
    videoFormat: "mp4",
    num: "01",
    license: "（闽）动审字[2011]第045号"
  }, 
  // Health: {
  //   baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/Health/",
  //   videoUrl:
  //     "https://eaydu-video.oss-cn-beijing.aliyuncs.com/Health/01.mp4",
  //   title: "精灵爱牙讲堂之口腔健康知识",
  //   setNum: 20,
  //   videoFormat: "mp4",
  //   num: "01",
  //   license: "（鄂）动审字[2015]第003号"
  // }, 
  // happy: {
  //   baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/happy/",
  //   videoUrl:
  //     "https://eaydu-video.oss-cn-beijing.aliyuncs.com/happy/01.mp4",
  //   title: "快乐故事屋",
  //   setNum: 52,
  //   videoFormat: "mp4",
  //   num: "01",
  //   license: "（浙）动审字[2016]第031号"
  // }, 
  // tiger: {
  //   baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/tiger/",
  //   videoUrl:
  //     "https://eaydu-video.oss-cn-beijing.aliyuncs.com/tiger/01.mp4",
  //   title: "乐乐虎大世界",
  //   setNum: 38,
  //   videoFormat: "mp4",
  //   num: "01",
  //   license: "（浙）动审字[2018]第024号"
  // }, 
  // fruit: {
  //   baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/fruit/",
  //   videoUrl:
  //     "https://eaydu-video.oss-cn-beijing.aliyuncs.com/fruit/01.mp4",
  //   title: "萌果乐多多之水果勋章（一）",
  //   setNum: 26,
  //   videoFormat: "mp4",
  //   num: "01",
  //   license: "（苏）动审字[2017]第007号"
  // }, 
  farm01: {
    baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/farm01/",
    videoUrl:
      "https://eaydu-video.oss-cn-beijing.aliyuncs.com/farm01/01.mp4",
    title: "丰丰农场之肥虫豆豆第一部",
    setNum: 13,
    videoFormat: "mp4",
    num: "01",
    license: "（豫）动审字[2016]第004号"
  }, farm02: {
    baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/farm02/",
    videoUrl:
      "https://eaydu-video.oss-cn-beijing.aliyuncs.com/farm02/01.mp4",
    title: "丰丰农场之肥虫豆豆第二部",
    setNum: 13,
    videoFormat: "mp4",
    num: "01",
    license: "（豫）动审字[2016]第005号"
  }, docotor: {
    baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/docotor/",
    videoUrl:
      "https://eaydu-video.oss-cn-beijing.aliyuncs.com/docotor/01.mp4",
    title: "熊猫博士",
    setNum: 39,
    videoFormat: "mp4",
    num: "01",
    license: "（川）动审字【2019】第001号"
  }, video2: {
    baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/video2/",
    videoUrl:
      "https://eaydu-video.oss-cn-beijing.aliyuncs.com/video2/01.mp4",
    title: "熊猫博士和托托（二）",
    setNum: 40,
    videoFormat: "mp4",
    num: "01",
  }, video3: {
    baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/video3/",
    videoUrl:
      "https://eaydu-video.oss-cn-beijing.aliyuncs.com/video3/01.mp4",
    title: "熊猫博士和托托（三）",
    setNum: 40,
    videoFormat: "mp4",
    num: "01",
  }, video4: {
    baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/video4/",
    videoUrl:
      "https://eaydu-video.oss-cn-beijing.aliyuncs.com/video4/1.mp4",
    title: "熊猫博士和托托第一季 英文版",
    setNum: 50,
    videoFormat: "mp4",
    num: "1",
  }, video5: {
    baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/video5/",
    videoUrl:
      "https://eaydu-video.oss-cn-beijing.aliyuncs.com/video5/1.mov",
    title: "熊猫博士和托托第二季 英文版",
    setNum: 40,
    videoFormat: "mov",
    num: "1",
  }, video6: {
    baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/video6/",
    videoUrl:
      "https://eaydu-video.oss-cn-beijing.aliyuncs.com/video6/1.mp4",
    title: "熊猫博士和托托第三季 英文版",
    setNum: 40,
    videoFormat: "mp4",
    num: "1",
  }, video7: {
    baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/video7/",
    videoUrl:
      "https://eaydu-video.oss-cn-beijing.aliyuncs.com/video7/1.mp4",
    title: "熊猫博士看世界：安全消防课",
    setNum: 3,
    videoFormat: "mp4",
    num: "1",
  }, video8: {
    baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/video8/",
    videoUrl:
      "https://eaydu-video.oss-cn-beijing.aliyuncs.com/video8/1.mp4",
    title: "熊猫博士看世界：垃圾分类总动员",
    setNum: 2,
    videoFormat: "mp4",
    num: "1",
  }, video9: {
    baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/video9/",
    videoUrl:
      "https://eaydu-video.oss-cn-beijing.aliyuncs.com/video9/1.mp4",
    title: "熊猫博士看世界：汽车的小秘密",
    setNum: 1,
    videoFormat: "mp4",
    num: "1",
  }, video10: {
    baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/video10/",
    videoUrl:
      "https://eaydu-video.oss-cn-beijing.aliyuncs.com/video10/1.mp4",
    title: "熊猫博士看世界：新冠肺炎全科普",
    setNum: 4,
    videoFormat: "mp4",
    num: "1",
  },legend: {
    baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/legend/",
    videoUrl:
      "https://eaydu-video.oss-cn-beijing.aliyuncs.com/legend/1.mp4",
    title: "摩比传说",
    setNum: 32,
    videoFormat: "mp4",
    num: "01",
    license: "（京）动审字【2013】第014号"
  },
}